import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class AlertsToastsService {
  constructor(private toastController: ToastController) {}

  async presentToast(message: string) {
    const alert = await this.toastController.create({
      animated: true,
      buttons: [{ role: 'cancel', icon: 'close' }],
      message: message,
      position: 'top',
      translucent: true,
      mode: 'ios',
      duration: 5000,
    });

    await alert.present();
  }
}
